import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
// Containers
import Full from '@/containers/Full'

// Flags
import FeatureFlags from '@/config/featureFlags'

// Components views
import EventsView from '@/views/components/EventsView'
import CommsView from '@/views/components/DeviceCommsView'
import CommsViewAlone from '@/views/components/DeviceCommsViewAlone'
// import EventsViewComponent from '@/views/components/EventsViewComponent'
import Profile from '@/views/components/Profile'

// Views
import DeviceList from '@/views/DeviceList'
import DeviceView from '@/views/DeviceView'
import Reports from '@/views/Reports'
import LeakList from '@/views/LeakList'
import Search from '@/views/Search'
import SearchDynamics from '@/views/SearchDynamics'
import AssignTenant from '@/views/AssignTenant'
import EventList from '@/views/EventList'
import IncompleteInstalls from '@/views/IncompleteInstalls'
import TenantsList from '@/views/TenantsList'
import TenantGroups from '@/views/TenantGroups'
import MessageList from '@/views/MessageList'
import UserList from '@/views/UserList'
import RolesAPI from '@/views/RolesAPI'
import AddApi2Role from '@/views/AddApi2Role'
import AddRole2Api from '@/views/AddRole2Api'
import OrdersManagement from '@/views/OrdersManagement'
import Login from '@/views/Login'
import Logout from '@/views/Logout'
// import LoginDynamics from '@/views/LoginDynamics'
import ResetPasswordConfirmation from '@/views/ResetPasswordConfirmation'
import ResetPassword from '@/views/ResetPassword'
import OTP from '@/views/OTP'
import QRCode from '@/views/QRCode'
import UpdateParameters from '@/views/UpdateParameters'
import MatlabParametersDictionary from '@/views/MatlabParametersDictionary'
import DeviceMatlabParameters from '@/views/DeviceMatlabParameters'
import RemovedDevices from '@/views/RemovedDevices'

import PartnerDashboard from '@/views/partner/Dashboard'
import PartnerDashboardV2 from '@/views/partner/v2/Dashboard'
import LeakInvestigationReports from '@/views/LeakInvestigationReports'

import Cards from '@/views/components/Cards'
import Modals from '@/views/components/Modals'
import Tables from '@/views/components/Tables'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import * as Routes from '../constants/routes'
import * as Roles from '../constants/roles'
Vue.use(Router)
Vue.use(store)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    if (to.query.page === 'reset-password') {
      next(Routes.RESET_PWD + '?token=' + to.query.reset_token)
    } else {
      next()
    }
    return
  }

  if (to.path === '/login/:dynamics') {
    next('/login/:dynamics')
  } else {
    if (store.getters.isAuthenticated) {
      switch (to.path) {
        case '/login/:dynamics':
          next(Routes.SEARCH + Routes.DYNAMICS)
          break
        case '/login':
          // next(Routes.SEARCH + Routes.NONDYNAMICS)
          break
        default:
          if (to.path === '/login') {
            next(Routes.SEARCH)
          } else { next(Routes.SEARCH + Routes.DYNAMICS) }
          break
      }
    } else {
      next(Routes.LOGIN)
    }
  }
}

const canAccessTo = (to) => {
  if (to === '/insurance-impact-dashboard' || to === '/leak-investigation-reports') {
    switch (store.getters.roleID) {
      case Roles.INSURANCE:
        return true
      default:
        return false
    }
  }
  return true
}

const determineHomeForUser = (to, from, next) => {
  if (to.meta.isHomeRelated) {
    if (store.getters.isAuthenticated) {
      var startPage
      switch (store.getters.roleID) {
        case Roles.INSURANCE:
          startPage = Routes.PARTNER_DASHBOARD_IM
          break
        case Roles.DEVICE_CONFIGURATION_MANAGER:
          startPage = Routes.UPDATE_PARAMETERS
          break
        default:
          startPage = Routes.SEARCH
          break
      }
      // if the to destination is not home it is a child of home
      // so we leave it alone, otherwise, redirect
      startPage = to.name !== 'Home' ? true : startPage
      if (canAccessTo(to.path)) {
        next(startPage)
      } else {
        next(Routes.PAGE_404)
      }
    } else {
      if (to.path === '/login/:dynamics') {
        next(Routes.LOGIN + Routes.DYNAMICS)
      } else {
        next(Routes.LOGIN)
      }
    }
  } else {
    if (canAccessTo(to.path)) {
      next()
    } else {
      next(Routes.PAGE_404)
    }
  }
}

const router = new Router({
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),

  routes: [
    {
      // catch all redirect
      path: '*', redirect: '/'
    },
    {
      path: Routes.LOGIN,
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: Routes.LOGIN + Routes.DYNAMICS,
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: Routes.RESET_PWD_CONF,
      component: ResetPasswordConfirmation,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: Routes.RESET_PWD,
      component: ResetPassword,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: Routes.ONE_TIME_PWD,
      component: OTP
      // beforeEnter: ifAuthenticated
    },
    {
      path: Routes.QR_CODE,
      component: QRCode
      // beforeEnter: ifAuthenticated
    },
    // Demo Views    
    // {
    //   path: FeatureFlags['demo-charts'] ? Routes.DEMO_CHARTS : Routes.PAGE_404,
    //   component: FeatureFlags['demo-charts'] ? DemoCharts : Page404
    // },
    {
      path: Routes.COMMS_VIEW + Routes.DEVICE_VIEW_LBID,
      name: 'CommsView',
      meta: {isHomeRelated: true},
      component: CommsView,
      props: true
    },
    {
      path: Routes.COMMS_VIEW_ALONE + Routes.DEVICE_VIEW_LBID,
      name: 'CommsViewAlone',
      meta: {isHomeRelated: true},
      component: CommsViewAlone,
      props: true
    },
    {
      path: Routes.EVENTS_VIEW + Routes.DEVICE_VIEW_LBID,
      name: 'EventsView',
      meta: {isHomeRelated: true},
      component: EventsView,
      props: true
    },
    {
      path: Routes.HOME,
      beforeEnter: determineHomeForUser,
      name: 'Home',
      component: Full,
      meta: {isHomeRelated: true},
      children: [
        {
          path: Routes.PARTNER_DASHBOARD,
          component: PartnerDashboard,
          meta: {isHomeRelated: true}
        },
        {
          path: Routes.PARTNER_DASHBOARD_IM,
          component: PartnerDashboardV2,
          meta: {isHomeRelated: true}
        },
        {
          name: 'Dashboard-V2',
          path: FeatureFlags['v2-dashboard'] ? Routes.PARTNER_DASHBOARD_V2 : Routes.LOGIN,
          component: FeatureFlags['v2-dashboard'] ? PartnerDashboardV2 : Login
        },
        {
          path: Routes.DEVICE_LIST,
          name: 'DeviceList',
          meta: {isHomeRelated: true},
          component: DeviceList
        },
        {
          path: Routes.EVENT_LIST,
          name: 'EventList',
          meta: {isHomeRelated: true},
          component: EventList
        },
        {
          path: Routes.INCOMPLETE_INSTALLS,
          name: 'IncompleteInstalls',
          meta: {isHomeRelated: true},
          component: IncompleteInstalls
        },
        {
          path: Routes.TENANTS_LIST,
          name: 'TenantsList',
          meta: {isHomeRelated: true},
          component: TenantsList
        },
        {
          path: Routes.TENANT_GROUPS,
          name: 'TenantGroups',
          meta: {isHomeRelated: true},
          component: TenantGroups
        },
        {
          path: Routes.REPORTS,
          name: 'Reports',
          meta: {isHomeRelated: true},
          component: Reports
        },
        {
          path: Routes.LEAK_INVESTIGATION_REPORTS,
          name: 'LeakInvestigationReports',
          meta: {isHomeRelated: true},
          component: LeakInvestigationReports
        },
        {
          path: Routes.DEVICE_VIEW + Routes.DEVICE_VIEW_ID,
          name: 'DeviceView',
          meta: {isHomeRelated: true},
          component: DeviceView,
          props: true
          // props: dynamicPropsFn
          // props: (route) => ({ query: route.query.q })
        },
        {
          path: Routes.LEAK_LIST,
          name: 'LeakList',
          meta: {isHomeRelated: true},
          component: LeakList
        },
        {
          path: Routes.ASSIGN_TENANT,
          name: 'AssignTenant',
          meta: {isHomeRelated: true},
          component: AssignTenant
        },
        {
          path: Routes.MESSAGE_LIST,
          name: 'MessageList',
          meta: {isHomeRelated: true},
          component: MessageList
        },
        {
          path: '/userlist:role_ID?',
          name: 'UserList',
          meta: { isHomeRelated: true },
          component: UserList
        },
        {
          path: Routes.ROLES_API,
          name: 'RolesAPI',
          meta: { isHomeRelated: true },
          component: RolesAPI
        },
        {
          path: Routes.ADD_API_2_ROLE,
          name: 'AddApi2Role',
          meta: { isHomeRelated: true },
          component: AddApi2Role
        },
        {
          path: Routes.ADD_ROLE_2_API,
          name: 'AddRole2Api',
          meta: { isHomeRelated: true },
          component: AddRole2Api
        },
        {
          path: Routes.ORDERS_MANAGEMENT,
          name: 'OrdersManagement',
          meta: { isHomeRelated: true },
          component: OrdersManagement
        },
        {
          path: Routes.SEARCH,
          name: 'Search',
          meta: {isHomeRelated: true},
          component: Search
        },
        {
          path: Routes.SEARCH + Routes.NONDYNAMICS,
          name: 'SearchDynamics',
          meta: {isHomeRelated: true},
          component: SearchDynamics
        },
        {
          path: Routes.UPDATE_PARAMETERS,
          name: 'UpdateParameters',
          meta: {isHomeRelated: true},
          component: UpdateParameters
        },
        {
          path: Routes.MATLAB_PARAMETERS_DICTIONARY,
          name: 'MatlabParametersDictionary',
          meta: {isHomeRelated: true},
          component: MatlabParametersDictionary
        },
        {
          path: Routes.DEVICE_MATLAB_PARAMETERS,
          name: 'DeviceMatlabParameters',
          meta: {isHomeRelated: true},
          component: DeviceMatlabParameters
        },
        {
          path: Routes.PROFILE_VIEW + Routes.DEVICE_VIEW_ID,
          name: 'ProfileView',
          meta: {isHomeRelated: true},
          component: Profile,
          props: true
        },
        {
          path: Routes.REMOVED_DEVICES,
          name: 'RemovedDevices',
          meta: {isHomeRelated: true},
          component: RemovedDevices
        },
        {
          path: Routes.LOGOUT,
          name: 'Logout',
          meta: {isHomeRelated: true},
          component: Logout
        },
        {
          path: Routes.COMPONENTS,
          redirect: '/components/buttons',
          name: 'Components',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: Routes.CARDS,
              name: 'Cards',
              component: Cards
            },
            {
              path: Routes.MODALS,
              name: 'Modals',
              component: Modals
            },
            {
              path: Routes.TABLES,
              name: 'Tables',
              component: Tables
            }
          ]
        }
      ]
    },
    {
      path: Routes.PAGES,
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: Routes.PAGE_404,
          name: 'Page404',
          component: Page404
        }
      ]
    }
  ]
})

router.beforeEach(determineHomeForUser)

router.afterEach(() => {
  // We can't destroy BootstrapVue modals after navigating, so let's remove it's classes manually
  // This is an issue after checking OTP - modal is destroyed, but Bootstrap Modal classes remain
  // See PD-203
  document.body.classList.remove('modal-open')
})

export default router
